import React from 'react'

const IconButton = ({
  icon,
  onClick,
  text,
  backgroundColor,
  color = '#fff',
  border,
  widthHalf = true,
  padding = true,
}) => {
  return (
    <button
      style={{
        width: widthHalf ? '49%' : 'auto',
        border: border ?? 'none',
        borderRadius: '5px',
        backgroundColor: backgroundColor,
        color: color,
        fontSize: '14px',
      }}
      onClick={onClick}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: '10px',
          padding: padding ? '0.4rem 1rem' : '0',
        }}
      >
        <div style={{ marginBottom: '0.2rem' }}>{icon}</div>
        <div>{text}</div>
      </div>
    </button>
  )
}

export default IconButton
